// extracted by mini-css-extract-plugin
module.exports = {"jobs":"styles_jobs__311MW"};